import { heroData } from '@/mocks/home';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20with%20warm%20vermillion%20coral%20and%20deep%20amber%20gradients%20flowing%20organic%20shapes%20inspired%20by%20newspaper%20headlines%20and%20social%20media%20feeds%20layered%20geometric%20patterns%20with%20soft%20light%20beams%20and%20dynamic%20motion%20texture%20editorial%20art%20style&width=1920&height=1200&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-200 text-sm font-medium mb-5 tracking-wide">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-4">
              {heroData.title}
              <br />
              <span className="text-accent-300">{heroData.subtitle}</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-100 font-medium mb-4 max-w-2xl mx-auto lg:mx-0">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-200 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="text-accent-400 font-heading text-xl md:text-2xl font-bold">{stat.value}</span>
                  <span className="text-foreground-300 text-xs md:text-sm">{stat.label}</span>
                  {i < heroData.stats.length - 1 && (
                    <span className="text-foreground-500/40 mx-1">|</span>
                  )}
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-foreground-50/15 hover:bg-foreground-50/25 text-foreground-50 border border-foreground-50/30 font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20collage%20featuring%20dynamic%20abstract%20compositions%20of%20newspaper%20clippings%20viral%20social%20media%20icons%20flame%20and%20trophy%20elements%20warm%20vermillion%20coral%20and%20deep%20gold%20color%20palette%20layered%20typography%20with%20Chinese%20characters%20modern%20magazine%20cover%20style%20bold%20graphic%20design&width=1000&height=750&seq=hero-visual-main&orientation=landscape"
                alt="每日大赛官网 - 吃瓜评选与爆料PK平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
            <div className="flex items-center gap-2 mt-4 justify-center lg:justify-start">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="w-8 h-8 rounded-full border-2 border-background-50 bg-secondary-300 flex items-center justify-center overflow-hidden">
                    <i className="ri-user-line text-secondary-600 text-xs"></i>
                  </div>
                ))}
              </div>
              <span className="text-foreground-300 text-xs">152,639 人正在围观吃瓜</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}